import {
  Col,
  Container,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
  Modal,
  Button,
} from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { ThreeDotSpinner } from "../loader";
import {
  baseUrl,
  dateFormate,
  formatBalance,
  formatWithDecimals,
  transactionurl,

} from "../../config/config";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
// import copy from "copy-to-clipboard";
import { apiService } from "../../service/api.service";
import { CopyToClipboard } from "react-copy-to-clipboard";
export const TransactionManagement = () => {
  let history = useNavigate();
  const [page, setPage] = useState(0);
  const [transactions, settransactions] = useState();
  const [totalItems, setTotalItems] = useState();
  const [walletaddress, setwalletaddresss] = useState("");
  const [contract_address, setcontract_address] = useState("");
  const [predictionDetail, setPredictionDetail] = useState([]);
  const [copied, setcopied] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [resultPrediction, setresultPrediction] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [showQAModal, setShowQAModal] = useState(false);
  const [selectedQA, setSelectedQA] = useState({ profileAnswers: [], bonusAnswers: [], type: "" });

  const formatAddress = (addr) => {
    return `${addr.substring(0, 4)}...${addr.substring(addr.length - 4)}`;
  };
  const [loader, setLoader] = useState(false);
  const props = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const wallet_address = searchParams.get("wallet_address");
  useEffect(() => {
    if (searchParams.get("wallet_address")) {
      setwalletaddresss(searchParams.get("wallet_address"));
      transaction_list(
        page,
        contract_address,
        searchParams.get("wallet_address"),
        false
      );
    } else if (searchParams.get("contract")) {
      setFiltered(true);
      setcontract_address(searchParams.get("contract"));
      transaction_list(page, searchParams.get("contract"), walletaddress, true);
    } else {
      transaction_list(page, contract_address, walletaddress, false);
    }
  }, []);



  async function downloadTwoColCsv() {
    try {
      setDownloading(true);
      const isScoped = !!effectiveContract;
      const resp = isScoped
        ? await apiService.exportVoterWinnerCsv(effectiveContract)
        : await apiService.exportAllPredictionVotersCsv();
      const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
      const fileName = isScoped
        ? `${effectiveContract}_voter_winner.csv`
        : "all_prediction_voters.csv";

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    } catch (e) {
      swal({ icon: "error", text: e?.message || "Download failed", button: "OK" });
    } finally {
      setDownloading(false);
    }
  }

  async function transaction_list(
    page,
    address,
    walletaddress,
    is_filterby_prediction
  ) {
    setLoader(true);
    try {
      const response = await apiService.transaction_list(
        page,
        address,
        walletaddress
      );
      if (response?.status == 200) {
        console.log("response.data.data", response.data.data);
        let responseData = response.data.data.predictionDetail;
        console.log("responseData============", responseData)
        if (is_filterby_prediction) {
          setresultPrediction(responseData[0].result?.toString());
          setPredictionDetail(responseData);
        } else {
          settransactions(responseData);
        }

        setTotalItems(response?.data?.data.totalRecords);

        setLoader(false);
      }
    } catch (error) {
      if (error?.response?.status == 401) {
        setLoader(false);

        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
          console.log("OK button clicked after error alert");
        });
      } else {
        setLoader(false);

        swal({
          icon: "error",
          text: error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.message,
          button: "OK",
        }).then((value) => {
        console.log("OK button clicked after error alert");
      });
    }
  }
  }
  function PredictionDetail(id) {
    history("/prediction-detail/" + id);
  }
  function handlePageChange(pageNumber) {
    console.log("??????page", pageNumber);
    if (page != pageNumber - 1) {
      setPage(pageNumber - 1);
      transaction_list(
        pageNumber - 1,
        contract_address,
        walletaddress,
        filtered
      );
    }
  }
const effectiveContract =
  (contract_address && contract_address.toLowerCase()) 

  const tooltip = <Tooltip id="tooltip">View</Tooltip>;
  const setcopytext = () => {
    setTimeout(() => {
      setcopied(false);
    }, "1000");
  };
  const copytooltip = (
    <Tooltip id="tooltip">{copied ? "Copied" : "Copy"}</Tooltip>
  );

  const handleOpenQAModal = (latestEntry, type) => {
    if (type === "profile") {
      setSelectedQA({
        profileAnswers: latestEntry?.profileQuestionAnswers || [],
        bonusAnswers: [],
        type: "profile"
      });
    } else if (type === "bonus") {
      setSelectedQA({
        profileAnswers: [],
        bonusAnswers: latestEntry?.bonusAnswers || [],
        type: "bonus"
      });
    }
    setShowQAModal(true);
  };

  const handleCloseQAModal = () => {
    setShowQAModal(false);
    setSelectedQA({ profileAnswers: [], bonusAnswers: [], type: "" });
  };
  return (
    <>
      <div className="dashboard-main-area">
        {loader == true ? <ThreeDotSpinner /> : ""}
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-3">
              <Col md={12} lg={11}>
                <div className="heading-top-area">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                      <div className="d-flex flex-column">
                        <h2 className="align-self-start m-0">Transaction Management</h2>
                        {/* {resultPrediction && resultPrediction?.length > 0 && resultPrediction?.[0] && (
                          <h5 className="mt-1">
                            Result : {resultPrediction?.[0]?.toUpperCase() + resultPrediction?.slice(1)}
                          </h5>
                        )} */}
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={downloadTwoColCsv}
                        disabled={downloading}
                        title={
                          effectiveContract
                            ? "Download voters/winners CSV for this prediction"
                            : "Download all prediction voters CSV"
                        }
                      >
                        {downloading ? "Preparing…" : "Download CSV"}
                      </button>
                    </div>

                  {resultPrediction &&
                    resultPrediction?.length > 0 &&
                    resultPrediction?.[0] && (
                      <h5>
                        Result :
                        {resultPrediction?.[0]?.toUpperCase() +
                          resultPrediction?.slice(1)}
                      </h5>
                    )}
                </div>
              </Col>
            </Row>
            <Row className="pb-4 justify-content-center">
              <Col md={12} lg={11}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Wallet Address</th>
                        <th>Prediction Participation</th>
                        <th>Amount Spent</th>
                        <th>Predicted</th>
                        <th>Prediction Type</th>
                        <th>Social Gated</th>
                        <th>Result</th>
                        <th>Date</th>
                        <th>Reward </th>
                        <th>Signup Ip</th>
                        <th>Age Range</th>
                        <th>Weekly Spending</th>
                        <th>Confidence Score </th>
                        <th>Profile Q&A</th>
                        <th>Bonus Q&A</th>
                        <th>View Transaction</th>
                      </tr>
                    </thead>
                    <tbody>
                      {totalItems != null &&
                        totalItems > 0 &&
                        transactions &&
                        transactions?.length > 0 ? (
                        transactions?.map((data, index) => {
                          console.log("data>>>>>>", data);
                          const { latestEntry, predictionDetails, _id } = data;
                          let priductedValue = latestEntry?.prediction?.toString();
                          const isSocialGated = predictionDetails?.isSocialGated ? "Yes" : "No";
                          let answer = "N/A";
                          if (
                            predictionDetails &&
                            predictionDetails?.result != null
                          ) {
                            answer = predictionDetails?.result?.toString();
                          }

                          return (
                            <tr>
                              <td>{index + 1}</td>

                              <td onClick={setcopytext}>
                                {formatAddress(_id?.user)}{" "}
                                <OverlayTrigger
                                  placement="top"
                                  overlay={copytooltip}
                                >
                                  <CopyToClipboard
                                    text={_id?.user}
                                    onCopy={() => setcopied(true)}
                                  >
                                    <i
                                      class="fa fa-clipboard"
                                      style={{ cursor: "pointer" }}
                                      aria-hidden="true"
                                    ></i>
                                  </CopyToClipboard>
                                </OverlayTrigger>
                              </td>
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  PredictionDetail(
                                    predictionDetails?.contract_address?.toLowerCase()
                                  )
                                }
                              >

                                {predictionDetails?.question?.length > 50 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">
                                        {predictionDetails?.question}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="hover-text">
                                      {predictionDetails?.question.substring(0, 50)}...
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  predictionDetails?.question
                                )}
                              </td>

                              <td>{latestEntry?.amount ? formatWithDecimals(latestEntry?.amount, predictionDetails?.decimal) : "N/A"}</td>
                              <td>
                                {priductedValue?.[0]?.toUpperCase() +
                                  priductedValue?.slice(1)}
                              </td>
                              <td>
                                {predictionDetails?.prediction_type ? predictionDetails?.prediction_type === "RISK-FREE" ? "Prize pool" : predictionDetails?.prediction_type : "N/A"}
                                {predictionDetails?.prediction_category !== "REGULAR" && (
                                  <>
                                    {predictionDetails?.prediction_category === "POLL" && " ( POLL )"}
                                    {predictionDetails?.prediction_category === "QUIZ" && " ( QUIZ )"}
                                    <span className="capitalized">
                                      &nbsp; {predictionDetails?.solo_type}
                                    </span>

                                  </>
                                )}
                              </td>
                              <td>{isSocialGated}</td>
                              <td>
                                {/* {answer[0].toUpperCase() + answer.slice(1)} */}
                                {(answer?.[0]?.toUpperCase() + answer?.slice(1))?.length > 10 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">
                                        {answer?.[0]?.toUpperCase() + answer?.slice(1)}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="hover-text">
                                      {(answer?.[0]?.toUpperCase() + answer?.slice(1))?.substring(0, 10)}...
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  answer?.[0]?.toUpperCase() + answer.slice(1)
                                )}
                              </td>

                              <td>{latestEntry?.date ? moment(latestEntry?.date).format(dateFormate) : "N/A"}</td>
                              {/* <td> {latestEntry?.points ? formatWithDecimals(latestEntry?.points, predictionDetails?.decimal) : "N/A"}</td> */}
                              <td> {latestEntry?.points ? latestEntry?.points : "-"}</td>
                              <td>{latestEntry?.signup_ip?latestEntry?.signup_ip:"-"}</td>
                              <td>{latestEntry?.user_age_range?latestEntry?.user_age_range:"-"}</td>
                              <td>{latestEntry?.user_weekly_spend?latestEntry?.user_weekly_spend:"-"}</td>
                              <td>{latestEntry?.confidenceLevel?latestEntry?.confidenceLevel:"-"}</td>
                              <td>
                                {latestEntry?.profileQuestionAnswers?.length > 0 ? (
                                  <>
                                    {/* <div style={{ fontSize: "12px", marginBottom: "4px" }}>
                                      <strong>{latestEntry.profileQuestionAnswers.length} answer(s)</strong>
                                    </div> */}
                                    <div style={{ fontSize: "11px", color: "#fff", marginBottom: "4px" }}>
                                      {latestEntry.profileQuestionAnswers[0]?.question?.length > 40
                                        ? `${latestEntry.profileQuestionAnswers[0].question.substring(0, 40)}...`
                                        : latestEntry.profileQuestionAnswers[0]?.question}
                                    </div>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      className="p-0"
                                      style={{ fontSize: "12px", padding: "0", color: "#fff" }}
                                      onClick={() => handleOpenQAModal(latestEntry, "profile")}
                                    >
                                      View All
                                    </Button>
                                  </>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                {latestEntry?.bonusAnswers?.length > 0 ? (
                                  <>
                                    {/* <div style={{ fontSize: "12px", marginBottom: "4px" }}>
                                      <strong>{latestEntry.bonusAnswers.length} answer(s)</strong>
                                    </div> */}
                                    <div style={{ fontSize: "11px", color: "#fff", marginBottom: "4px" }}>
                                      {latestEntry.bonusAnswers[0]?.question?.length > 40
                                        ? `${latestEntry.bonusAnswers[0].question.substring(0, 40)}...`
                                        : latestEntry.bonusAnswers[0]?.question}
                                    </div>
                                    <Button
                                      variant="link"
                                      size="sm"
                                      className="p-0"
                                      style={{ fontSize: "12px", padding: "0",color: "#fff" }}
                                      onClick={() => handleOpenQAModal(latestEntry, "bonus")}
                                    >
                                      View All
                                    </Button>
                                  </>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                <a
                                  href={transactionurl + latestEntry?.transaction_hash}
                                  target="_blank"
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={tooltip}
                                  >
                                    <i
                                      class="fa fa-eye"
                                      style={{ cursor: "pointer" }}
                                      aria-hidden="true"
                                    ></i>
                                  </OverlayTrigger>
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : totalItems != null &&
                        totalItems > 0 &&
                        predictionDetail &&
                        predictionDetail?.length > 0 ? (
                        predictionDetail?.[0]?.prediction_id?.map((data, index) => {
                          console.log("predictionDetail===================", predictionDetail)
                          let priductedValue = data?.prediction?.toString();
                          let answer = "N/A";
                          if (predictionDetail?.[0]?.result != null) {
                            answer = predictionDetail?.[0]?.result?.toString();
                          }

                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{formatAddress(data?.user)}</td>
                              <td>
                                {predictionDetail?.[0]?.question?.length > 50
                                  ? predictionDetail?.[0]?.question?.slice(0, 50) +
                                  "..."
                                  : predictionDetail?.[0]?.question}
                              </td>
                              <td>{formatWithDecimals(data?.amount, data?.prediction_id?.decimal)} {data?.prediction_id?.symbol}</td>

                              <td>
                                {priductedValue?.[0]?.toUpperCase() +
                                  priductedValue?.slice(1)}
                              </td>
                              <td>
                                {predictionDetail?.[0]?.prediction_type ? predictionDetail?.[0]?.prediction_type === "RISK-FREE" ? "Prize pool" : predictionDetail?.[0]?.prediction_type : "N/A"}
                                {predictionDetail?.[0]?.prediction_category !== "REGULAR" && (
                                  <>
                                    {predictionDetail?.[0]?.prediction_category === "POLL" && " ( POLL )"}
                                    {predictionDetail?.[0]?.prediction_category === "QUIZ" && " ( QUIZ )"}
                                  </>
                                )}
                              </td>
                              <td>
                                

                                {(answer?.[0]?.toUpperCase() + answer?.slice(1))?.length > 10 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip">
                                        {answer?.[0]?.toUpperCase() + answer?.slice(1)}
                                      </Tooltip>
                                    }
                                  >
                                    <span className="hover-text">
                                      {(answer?.[0]?.toUpperCase() + answer?.slice(1))?.substring(0, 10)}...
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  answer?.[0]?.toUpperCase() + answer?.slice(1)
                                )}
                              </td>
                              <td>{moment(data?.date).format(dateFormate)}</td>
                              <td> {formatWithDecimals(data?.reward_amount, predictionDetail?.[0]?.decimal)} {predictionDetail?.[0]?.symbol}</td>
                             


                          
                             
                              <td>
                                <a
                                  href={transactionurl + data?.transaction_hash}
                                  target="_blank"
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={tooltip}
                                  >
                                    <i
                                      class="fa fa-eye"
                                      style={{ cursor: "pointer" }}
                                      aria-hidden="true"
                                    ></i>
                                  </OverlayTrigger>
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="no-dat-found-box">
                          <td colSpan={16}>
                            <img
                              src={
                                require("../../assets/images/no-data.svg")
                                  .default
                              }
                              alt="da"
                            />
                            <h3 className="text-center text-light">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {totalItems && totalItems > 0 ? (
                    <Pagination
                      activePage={page + 1}
                      itemsCountPerPage={10}
                      totalItemsCount={totalItems}
                      pageRangeDisplayed={5}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  ) : null}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      {/* Q&A Modal */}
      <Modal show={showQAModal} onHide={handleCloseQAModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedQA.type === "profile" ? "Profile Question Answers" : "Bonus Question Answers"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Profile Question Answers */}
          {selectedQA.profileAnswers?.length > 0 && (
            <div className="profile-question-answers-list">
              {selectedQA.profileAnswers.map((qa, idx) => (
                <div key={qa.profileQuestionId || idx} className="mb-3 p-3 rounded" style={{ backgroundColor: "rgba(0,0,0,0.05)", border: "1px solid #eee" }}>
                  <p className="mb-1 small text-muted">Question</p>
                  <p className="mb-2">{qa.question || "-"}</p>
                  <p className="mb-1 small text-muted">Type: {qa.type || "-"}</p>
                  <p className="mb-1 small text-muted">Answer(s)</p>
                  <p className="mb-0">
                    {qa.selectedOptions && qa.selectedOptions.length > 0
                      ? qa.selectedOptions.join(", ")
                      : "-"}
                  </p>
                </div>
              ))}
            </div>
          )}

          {/* Bonus Question Answers */}
          {selectedQA.bonusAnswers?.length > 0 && (
            <div className="bonus-question-answers-list">
              {selectedQA.bonusAnswers.map((qa, idx) => (
                <div key={qa.bonusQuestionId || idx} className="mb-3 p-3 rounded" style={{ backgroundColor: "rgba(0,0,0,0.05)", border: "1px solid #eee" }}>
                  <p className="mb-1 small text-muted">Question</p>
                  <p className="mb-2">{qa.question || "-"}</p>
                  <p className="mb-1 small text-muted">Type: {qa.type || "-"}</p>
                  <p className="mb-1 small text-muted">Answer(s)</p>
                  <p className="mb-0">
                    {qa.selectedOptions && qa.selectedOptions.length > 0
                      ? qa.selectedOptions.join(", ")
                      : "-"}
                  </p>
                </div>
              ))}
            </div>
          )}

          {selectedQA.profileAnswers?.length === 0 && selectedQA.bonusAnswers?.length === 0 && (
            <p className="mb-0">No question answers available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseQAModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
